<template>
    <div>
        <div class="container">
            <div class="field">
                <a :class="{
                    button: true,
                    'is-primary': !editing
                }" @click="editing = !editing">{{ editing ? 'Cancel Editing' : 'Edit Image' }}</a>
                <a class="button" @click="deleteImage()">
                    Delete Image
                </a>
            </div>
            <div class="columns" v-if="!editing">
                <div class="column is-8">
                    <div>
                        <strong>Thumbnail</strong>
                        ({{ image.thumbnail_size | prettyBytes }} - {{ image.thumbnail_width }}x{{ image.thumbnail_height }}px)
                        <br/>
                        <img :src="image.thumbnail_path">
                    </div>
                    <div>
                        <strong>Normal Size</strong>
                        ({{ image.normal_size | prettyBytes }} - {{ image.normal_width }}x{{ image.normal_height }}px)
                        <br/>
                        <img :src="image.normal_path">
                    </div>
                </div>
                <div class="column is-4">
                    <h2 class="title">Content linked to this image</h2>
                    <div class="field">
                        <h3 class="subtitle">Products</h3>
                        <div v-for="product in linkedProducts">
                            <router-link :to="{ name: 'product', params:{id: product.id}}">
                                {{ product.name }}
                            </router-link>
                        </div>
                        <div v-if="linkedProducts.length === 0">
                            No products linked to this image
                        </div>
                    </div>
                    <div class="field">
                        <h3 class="subtitle">Bundles</h3>
                        <div v-for="bundle in linkedBundles">
                            <router-link :to="{ name: 'bundle', params:{id: bundle.id}}">
                                {{ bundle.name }}
                            </router-link>
                        </div>
                        <div v-if="linkedBundles.length === 0">
                            No bundles linked to this image
                        </div>
                    </div>
                    <div class="field">
                        <h3 class="subtitle">Items</h3>
                        <div v-for="item in linkedItems">
                            <router-link :to="{ name: 'item', params:{id: item.id}}">
                                {{ item.name }}
                            </router-link>
                        </div>
                        <div v-if="linkedItems.length === 0">
                            No items linked to this image
                        </div>
                    </div>
                    <div class="field">
                        <h3 class="subtitle">Pages</h3>
                        <div v-for="page in linkedPages">
                            <router-link :to="{ name: 'page', params:{id: page.id}}">
                                {{ page.name }}
                            </router-link>
                        </div>
                        <div v-if="linkedPages.length === 0">
                            No pages linked to this image
                        </div>
                    </div>
                </div>
            </div>
            <div v-if="!editing">
                <strong v-if="image.full_path">Full Size (possibly scaled)</strong>
                <strong v-else>Full Size Version Not Available</strong>
                <span v-if="image.full_path">
                    ({{ image.full_size | prettyBytes }} - {{ image.full_width }}x{{ image.full_height }}px)
                    <br/>
                    <img :src="image.full_path">
                </span>
            </div>
        </div>
        <div v-if="editing">
            <br/>
            <image-form :image="image" @saved="editing = false"></image-form>
        </div>
    </div>
</template>

<script>
    import {mapGetters} from "vuex"
    import {DELETE_IMAGE} from "../../store/mutation-types"
    export default {
        data() {
            return {
                editing: false,
                showImage: 'thumbnail',
                image: this.$store.state.images.all.find(image => image.id === parseInt(this.$route.params.id))
            }
        },
        methods: {
            deleteImage() {
                let confirm = window.confirm('Are you sure? All links to this image will be deleted as well.')
                if (confirm) {
                    this.$store.dispatch(DELETE_IMAGE, this.image)
                        .then(data => {
                            this.$router.push({name: 'images'})
                        })
                }
            }
        },
        computed: Object.assign({}, mapGetters(['images', 'imageables', 'products', 'bundles', 'items', 'pages']), {
            imageLinks() {
                return this.imageables.filter(imageable => imageable.image_id === this.image.id)
            },
            linkedProducts() {
                let productIDs = []
                for (let link in this.imageLinks) {
                    if (this.imageLinks[link].imageable_type === 'Product') {
                        productIDs.push(this.imageLinks[link].imageable_id)
                    }
                }

                return this.products.filter(product => productIDs.indexOf(product.id) !== -1)
            },
            linkedBundles() {
                return this.bundles.filter(bundle => bundle.image_id === this.image.id)
            },
            linkedItems() {
                return this.items.filter(item => item.image_id === this.image.id)
            },
            linkedPages() {
                return this.pages.filter(page => page.image_id === this.image.id)
            }
        }),
    };
</script>



// WEBPACK FOOTER //
// ImageEdit.vue?61afba10